/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {getScenarioPlan} from '../api'

export const useMutationGetScenarioPlan = createReactQueryMutationHook('getScenarioPlan', getScenarioPlan)
